import {Injectable} from '@angular/core';
import {Tenant} from '../interfaces/tenant';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {ServiceAnswer} from '../../shared/service-answer';
import {GeneralService} from './general.service';
import {UiSettingsService} from '../../shared/ui-settings.service';
import { SuperuserServiceModule } from '../superuser-service.module';

/**
 * A service for tenant management.
 */
@Injectable({
  providedIn: SuperuserServiceModule
})
export class TenantCacheService extends GeneralService<Tenant> {

  constructor(http: HttpClient, private uiSettingsService: UiSettingsService) {
    super(http, uiSettingsService, 'tenantcaches', 'tenantcache');
  }

  /**
   * Executes application cache removing.
   */
  public async removeCache(tenantId: number): Promise<ServiceAnswer<any>> {
    return await this.executeHttpRequest(
      url => this.removeCacheSingle(url),
      tenantId
    );
  }

  /**
   * Removes the tenant cache of the given tenant.
   * @param userId The id of the tenant to be removed.
   */
  public async removeCacheSingle(url: string): Promise<ServiceAnswer<any>> {
    const serviceAnswer: ServiceAnswer<any> = {isOk: null};

    try {
      const entityObject = await this.http.delete(
        `${url}`,
        {
        })
        .pipe(
          map((value: any) => {
            return JSON.stringify(value);
          }))
        .toPromise();
      serviceAnswer.isOk = true;
      serviceAnswer.data = JSON.parse(entityObject);
      return serviceAnswer;
    } catch (error) {
      console.error(`Error when deleting tenant cache of tenant: ${JSON.stringify(error)}`);
      serviceAnswer.isOk = false;
      serviceAnswer.errorCode = error.status;
      serviceAnswer.errorMessage = error.message + '. Answer body: ' + JSON.stringify(error.error);
      return serviceAnswer;
    }
  }
}
